const apiUrl = {
    prod: 'https://backendbiling.nipo-gps.com/',
    dev: 'https://billingdev.nipo-gps.com/',
    dev2: 'https://billingdev2.nipo-gps.com/',
    dev3: 'https://billingdev3.nipo-gps.com/'
}

export { apiUrl }
